import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { concatMap, delay, finalize, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$: Observable<boolean> = this.loadingSubject.asObservable();

  public showLoaderUntilCompleted<T>(obs$: Observable<T>): Observable<T> {
    return of(null).pipe(
      tap(() => this.loadingOn()),
      concatMap(() => obs$),
      delay(200),
      finalize(() => this.loadingOff()),
    );
  }

  public loadingOn(): void {
    setTimeout(() => {
      this.loadingSubject.next(true);
    }, 0);
  }

  public loadingOff(): void {
    setTimeout(() => {
      this.loadingSubject.next(false);
    }, 0);
  }
}
